import { type ApiProblem, call } from '@rental/contracts/client'
import type { QueryClient } from '@tanstack/react-query'
import { api, load } from '../api'

/** S5 (PAY-6): the drawers, shared by the Cassa screen and every money form's drawer field. */
export const CASH_QUERY_KEY = ['cash'] as const

export const loadCash = () => load(call(api.GET('/v1/staff/cash')))

/** The Cassa screen asks again every minute: another device may open or close a drawer. */
export const CASH_REFRESH_MS = 60_000

/** What a count can be, as the server takes it: up to a million euros in the drawer. */
export const MAX_COUNT_CENTS = 100_000_000

/**
 * A money form refused for its drawer (closed, or being counted, on another
 * device meanwhile): the drawer field shows the drawers as they are now.
 */
export async function refreshDrawersAfter(
  queryClient: QueryClient,
  problem: ApiProblem,
): Promise<void> {
  if (problem.kind === 'api' && problem.code.startsWith('cash_drawer')) {
    await queryClient.invalidateQueries({ queryKey: CASH_QUERY_KEY })
  }
}
